<div class="popup_main_div add_edit_matter_main" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>Client Secret Key</span>
    <button class="btnval" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon style="margin-left: 575px">close</mat-icon>
    </button>
  </h2>
  <div class="secret-popup">
    <div class="success-icon">
      <mat-icon>check</mat-icon>
    </div>

    <h2>Your app has been created successfully!</h2>

    <p class="subtitle">Here is your new secret. This is the only time it will be shown.</p>

    <div class="secret-label">Your Secret</div>

    <div class="secret-box">
      <input #secretInput readonly [value]="data.secret" />

      <button
        mat-stroked-button
        color="primary"
        class="copy-btn"
        (click)="copySecret(secretInput.value)"
      >
        <mat-icon>file_copy</mat-icon>

        Copy
      </button>
    </div>

    <div class="warning-box">
      <div class="warning-icon">
        <mat-icon>warning</mat-icon>
      </div>

      <div>
        <h3>This secret cannot be retrieved later.</h3>

        <p>
          For your security, we never store your secret in a way that allows us to retrieve it.
          <br />

          <strong>You must save it now.</strong>

          <br />

          If you lose this secret, you will need to use
          <strong>Generate New Secret</strong>
          to create another one.
        </p>
      </div>
    </div>

    <div class="footer">
      <button mat-raised-button color="primary" (click)="dialogRef.close()">
        I have saved my secret
      </button>
    </div>

    <p class="bottom-text">Make sure to save your secret in a secure location.</p>
  </div>
</div>
